import { render, staticRenderFns } from "./ProblemList.vue?vue&type=template&id=3c657bd1&scoped=true"
import script from "./ProblemList.vue?vue&type=script&lang=js"
export * from "./ProblemList.vue?vue&type=script&lang=js"
import style0 from "./ProblemList.vue?vue&type=style&index=0&id=3c657bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c657bd1",
  null
  
)

export default component.exports